import { useIntl } from 'react-intl';
import { EmptyState } from '@astryxdesign/core/EmptyState';
import { Button } from '@astryxdesign/core/Button';
import { Center } from '@astryxdesign/core/Center';

export function NotFoundPage() {
  const intl = useIntl();
  return (
    <Center height="60dvh">
      <EmptyState
        title={intl.formatMessage({ id: 'notFound.title' })}
        description={intl.formatMessage({ id: 'notFound.description' })}
        actions={<Button label={intl.formatMessage({ id: 'notFound.home' })} href="/" variant="primary" />}
      />
    </Center>
  );
}
